import React from 'react';
import { BrandMark } from './BrandMark';
interface FooterProps {
  onOpenForm: () => void;
}
export function Footer({
  onOpenForm
}: FooterProps) {
  return <footer className="bg-navy-600 py-12 border-t border-white/10" data-id="element-144">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-145">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12" data-id="element-146">
          <div className="md:col-span-1" data-id="element-147">
            <a href="/" className="inline-flex items-center gap-2.5 mb-3 hover:opacity-85 transition-opacity" aria-label="Blinkblis home" data-id="element-148">
              <BrandMark className="w-8 h-8" data-id="element-149" />
              <span className="text-lg font-bold tracking-tight leading-none" data-id="element-150">
                <span className="text-white" data-id="element-151">blink</span>
                <span className="text-emerald-400" data-id="element-152">blis</span>
              </span>
            </a>
            <p className="text-slate-400 text-sm font-medium mb-4" data-id="element-153">
              Smart finance, smarter decisions.
            </p>
            <p className="text-gold text-xs font-bold tracking-widest uppercase" data-id="element-154">
              The goal is not panic. It is visibility.
            </p>
          </div>

          <div data-id="element-155">
            <h4 className="text-white font-bold mb-4" data-id="element-156">Resources</h4>
            <ul className="space-y-2 text-sm text-slate-400 font-medium" data-id="element-157">
              <li data-id="element-158">
                <a href="#comparison" className="hover:text-white transition-colors" data-id="element-159">
                  Alternative Reporting Frameworks
                </a>
              </li>
              <li data-id="element-160">
                <button onClick={onOpenForm} className="hover:text-white transition-colors text-left" data-id="element-161">
                  The Playbook
                </button>
              </li>
              <li data-id="element-162">
                <a href="#faq" className="hover:text-white transition-colors" data-id="element-163">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-164">
            <h4 className="text-white font-bold mb-4" data-id="element-165">Editorial</h4>
            <ul className="space-y-2 text-sm text-slate-400 font-medium" data-id="element-166">
              <li data-id="element-167">
                <a href="/research-methodology" className="hover:text-white transition-colors" data-id="element-168">
                  Research Methodology
                </a>
              </li>
              <li data-id="element-169">
                <a href="/editorial-standards" className="hover:text-white transition-colors" data-id="element-170">
                  Editorial Standards
                </a>
              </li>
              <li data-id="element-171">
                <a href="/how-we-make-money" className="hover:text-white transition-colors" data-id="element-172">
                  How We Make Money
                </a>
              </li>
              <li data-id="element-173">
                <a href="/corrections" className="hover:text-white transition-colors" data-id="element-174">
                  Corrections Policy
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-175">
            <h4 className="text-white font-bold mb-4" data-id="element-176">Compliance</h4>
            <ul className="space-y-2 text-sm text-slate-400 font-medium" data-id="element-177">
              <li data-id="element-178">
                <a href="#" className="hover:text-white transition-colors" data-id="element-179">
                  Affiliate Disclosure
                </a>
              </li>
              <li data-id="element-180">
                <a href="#" className="hover:text-white transition-colors" data-id="element-181">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-182">
                <a href="#" className="hover:text-white transition-colors" data-id="element-183">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 text-xs text-slate-500 leading-[1.6]" data-id="element-184">
          <p className="mb-4" data-id="element-185">
            © {new Date().getFullYear()} Blinkblis. All rights reserved.
          </p>
          <p data-id="element-186">
            Blinkblis is an independent comparison platform. We are not a
            lender, credit repair organization, or financial advisor.
            Information provided is for educational purposes only. Consult
            qualified professionals for personalized advice. Reading scores,
            terms, and product features may change — verify directly with each
            provider before signing up.
          </p>
        </div>
      </div>
    </footer>;
}